import { eLeadStatus } from '../../../../providers/SocketsProvider/Sockets.enums';

export function shortName(name: string) {
  if (!name) {
    return 'na';
  }
  return name
    .split(' ')
    .map((name) => name[0])
    .join('');
}

export function showStatusEmoji(status: string) {
  switch (status) {
    case eLeadStatus.NEUTRAL:
      return '';
    case eLeadStatus.URGENT:
      return '🔥 ';
    case eLeadStatus.IMPORTANT:
      return '⭐ ';
    case eLeadStatus.PENDING:
      return '⌛ ';
    case eLeadStatus.STUCK:
      return '🧊 ';
    default:
      return '';
  }
}

export function formatDateShort(date: string) {
  if (!date) {
    return 'na.';
  }
  const dateObj = new Date(date);
  return dateObj.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
  });
}
